import FormattedMessage from 'I18n/components/FormattedMessage';
import TaskFormError from 'task-forms-lib/tasks/TaskFormError';
import TaskFormLoading from 'task-forms-lib/tasks/TaskFormLoading';
import UIButton from 'UIComponents/button/UIButton';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useCloseTaskForm } from '../../hooks/useCloseTaskForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LoadingComponent({
  pastDelay
}) {
  const onClose = useCloseTaskForm();
  return pastDelay ? /*#__PURE__*/_jsx(TaskFormLoading, {
    edit: true,
    onClose: onClose
  }) : null;
}
function ErrorComponent({
  retry
}) {
  const onClose = useCloseTaskForm();
  return /*#__PURE__*/_jsx(TaskFormError, {
    edit: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "taskForm.loadingErrorMessage"
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: retry,
        use: "primary",
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "taskForm.loadingErrorRetryMessage"
        })
      })]
    })
  });
}
export default Loadable({
  loader: () => import( /* webpackChunkName: "task-form" */'./BaseTaskForm').then(mod => mod.default),
  LoadingComponent,
  ErrorComponent
});